module.exports = __webpack_public_path__ + "static/media/HoursCorrection.ba38d824.svg";